<div class="col-12">
  @for (type of documentTypeList; track type) {
    <div class="row mb-3">
      <div class="col-12">
        <div class="row">
          <div class="col-auto pe-0 pt-2">
            @if (model.documents[type]?.document?.url) {
              <a
                [href]="$safeNavigationMigration(model.documents[type].document?.url)" download><i class="bi h5 bi-download"></i></a>
              }
              @if (!model.documents[type]?.document?.url) {
                <i class="bi bi-download h5 not-implemented"></i>
              }
            </div>
            <div class="col-4 d-flex align-items-center">
              <h3 class="fs-6 fw-bold mb-0">{{ ('complianceDocumentType.' + type) | translate }}</h3>
            </div>
            <div class="col-3">
              <label>
                <input type="file" class="d-none" (change)="onClickUpload($event, type)">
                <div class="btn btn-primary fw-bold"><i class="bi bi-upload"></i> Upload</div>
              </label>
            </div>
            <div class="col">
              <div class="input-group d-flex align-items-center">
                <label class="fw-bold small me-2">Validity Date</label>
                <input type="date" class="form-control"
                  [(ngModel)]="upload[type].expireAtDate"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="col">
              <div class="input-group d-flex align-items-center">
                <label class="fw-bold small me-2">Status</label>
                <select [(ngModel)]="upload[type].status" [ngModelOptions]="{standalone: true}" class="form-control">
                  <option value="pending">Pending</option>
                  <option value="refused">Refused</option>
                  <option value="approved">Approved</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
